"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscreteProgressBarWidget_UNFINISHED = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var ProgressBarWidgets_1 = require("./ProgressBarWidgets");
/** While functional, the discrete progress bar widget is disapproved by Visual Design. */
// tslint:disable:class-name
var DiscreteProgressBarWidget_UNFINISHED = /** @class */ (function (_super) {
    tslib_1.__extends(DiscreteProgressBarWidget_UNFINISHED, _super);
    function DiscreteProgressBarWidget_UNFINISHED() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DiscreteProgressBarWidget_UNFINISHED.prototype.render = function () {
        var fractionComplete = this.props.currentStep / this.props.totalSteps;
        return (React.createElement(ProgressBarWidgets_1.ProgressBarContainer, { width: this.props.width },
            React.createElement(ProgressBarWidgets_1.ProgressCompleteBar, { fractionComplete: fractionComplete }, fractionComplete === 1 ? null : React.createElement(ProgressBarWidgets_1.ProgressBarAnimation, { containerWidth: this.props.width * fractionComplete }))));
    };
    return DiscreteProgressBarWidget_UNFINISHED;
}(React.PureComponent));
exports.DiscreteProgressBarWidget_UNFINISHED = DiscreteProgressBarWidget_UNFINISHED;
//# sourceMappingURL=DiscreteProgressBarWidget.js.map